import React from 'react';
import mergeI18n from '../../lib/util/merge-i18n';
import i18n from './i18n';

function Spinner ({ language, message, description }) {
	const __ = mergeI18n(language, i18n);

	return (
		<div id='spinner' className='row'>
			<div className='col-md-8 col-md-offset-2 text-center center-block'>
				<div className='row'>
					<div className='col-md-8 col-md-offset-2'>
						<div className='spinner' />
						<h3>{__[message]}</h3>
						<p>{__[description]}</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Spinner;
